import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { QRScan } from 'app/core/qrscan/qrscan.types';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class QRScanService {
    private _user: ReplaySubject<QRScan> = new ReplaySubject<QRScan>(1);
    private _qrcode: ReplaySubject<any> = new ReplaySubject<any>(1);
    private _baseURL: string = environment.apiOrigin + '/api/'

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: QRScan) {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<QRScan> {
        return this._user.asObservable();
    }

    /**
     * Setter & getter for qrcode
     *
     * @param value
     */
    set qrcode(value) {
        // Store the value
        console.log(value)
        this._qrcode.next(value);
    }

    get qrcode$(): Observable<any> {
        return this._qrcode.asObservable();
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current logged in user data
     */
    getQR() {
        return this._httpClient.get(this._baseURL + 'auth/qrcode');
    }
    /**
     * Get the current logged in user data
     */
    getActivatedRequests() {
        return this._httpClient.get(this._baseURL + 'auth/qrcode/search-history/list');
    }
    /**
     * Get the current logged in user data
     */
    saveQRDetails(data) {
        return this._httpClient.post(this._baseURL + 'auth/qrcode/search-history', { data: data });
    }
    /**
     * Get the current logged in user data
     */
    removeDetails(id) {
        return this._httpClient.get(this._baseURL + 'auth/qrcode/search-history/' + id);
    }
}
